import { PdfModalPipViewport, type PdfModalPipSourceRef } from "@/components/pdf-modal-pip";

export type SourcePdfRef = PdfModalPipSourceRef;

interface SpecPilotSourcePdfPanelProps {
  sourcePdf?: SourcePdfRef | null;
  sourceId: string;
  pageNumber: number;
  className?: string;
}

export function SpecPilotSourcePdfPanel({
  sourcePdf,
  sourceId,
  pageNumber,
  className,
}: SpecPilotSourcePdfPanelProps) {
  return (
    <PdfModalPipViewport
      sourcePdf={sourcePdf}
      sourceId={sourceId}
      initialPage={pageNumber}
      className={className}
    />
  );
}
